import Heading from "~/components/lib/Heading";
import Link from "~/components/lib/Link";
import type { BlogCategory } from "~/entities/blog/types";

type Props = {
  categories: BlogCategory[];
};

const Categories: React.FC<Props> = ({ categories }) => (
  <nav
    aria-label="Categories"
    className="blog-sidebar__categories"
  >
    <Heading
      element="h3"
      size="base"
      className="blog-sidebar__title"
    >
      Categories
    </Heading>
    <ul className="blog-sidebar__category-list">
      {categories.map((category) => (
        <li
          key={category.slug}
          className="blog-sidebar__category"
        >
          <Link
            to={category.path}
            className="blog-sidebar__category-link"
          >
            {category.name}
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);

export default Categories;
